<img class="logo" alt="logo" [src]="logoPath" />
